import { render } from "./MiezzButtonUpload.vue?vue&type=template&id=b8f04d6a&scoped=true&ts=true"
import script from "./MiezzButtonUpload.vue?vue&type=script&lang=ts"
export * from "./MiezzButtonUpload.vue?vue&type=script&lang=ts"

import "./MiezzButtonUpload.vue?vue&type=style&index=0&id=b8f04d6a&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f04d6a"]])

export default __exports__